<template>
  <div>
    <b-row
      v-if="etrail"
      :class="etrailClasses.row1"
    >
      <b-col :class="etrailClasses.col1">
        <div
          :class="etrailClasses.div1"
          @click.prevent="openModal(modalType)"
        >
          <h6 :class="etrailClasses.header1">
            Contact Us
          </h6>
        </div>
      </b-col>
      <Etrail
        ref="EtrailRef"
        :booking="booking"
        contact-mode="pre-travel"
        source="urgAssistance"
      />
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isUrgentCheck } from "@/partials/contact-us/contact-us.module.js";
import Etrail from "@/partials/contact-us/etrail/index.vue";
export default {
  components: {
    Etrail,
  },
  data() {
    return {
      etrail: false,
      modalType: "EtrailRef",
      etrailClasses: {
        row1: "",
        col1: "",
        div1: "",
        header1: ""
      },
    };
  },
  computed: {
    ...mapGetters({
      booking: "booking/getBooking",
      departureDate: "booking/getDeptDate",
      fil: "booking/getFil",
      firstFlightItineraryItem: "booking/getFirstFlightItineraryItem",
      destination: "booking/getDestination",
      tripHasStarted: "booking/getTripStarted",
      tripHasEnded: "booking/getTripEnded",
      userData: "auth/getUserData",
      userType: "auth/getUserType",
      friendFamily: "friendFamily/isFriendFamily",
    }),

    isUrgent() {
      if (this.booking) {
        return isUrgentCheck(this.booking,  this.departureDate);
      }
      return null;
    },
  },
  created() {
    this.calculateDisplayEtrail()
  },
  methods: {
    openModal(item) {
      if (item === "ContactRef" || item === "EtrailRef") {
        this.$refs[item].show();
      } else {
        this.$refs[item].showModal();
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.formatEtrailClasses(true);
        return true;
      } else {
        this.formatEtrailClasses(false);
        return false;
      }
    },
    formatEtrailClasses(isMob){
      const _obj = {};
      if (isMob){
        _obj.row1 = "home-nav-etrail-mobile d-block";
        _obj.col1 = "";
        _obj.div1 = "";
        _obj.header1 = "";
      } else {
        _obj.row1 = "d-none d-md-none d-lg-flex";
        _obj.col1 = "home-nav-container-header-etrail p-0 d-flex";
        _obj.div1 = "etrail-msg d-none d-md-none d-lg-flex p-0";
        _obj.header1 = "p-0 m-0"
      }
      this.etrailClasses = _obj;
    },
    calculateDisplayEtrail() {
      if (this.fil === "M" && !this.isUrgent) {
        if (
          !this.tripHasEnded &&
          !this.friendFamily &&
          this.destination !== "INS"
        ) {
          this.etrail = true;
        } else if (this.destination !== "INS" && !this.tripHasStarted) {
          this.etrail = true;
        }
      }
      if (
        (this.fil === "P" && this.booking.feedback_exists !== true) ||
        (this.booking &&
          this.booking.numDaysSinceAuth <= 10 &&
          this.booking.feedback_exists !== true)
      ) {
        this.feedback = true;
      }
      this.isMobile();
    },
  },
  watch: {
    booking: function() {
      this.calculateDisplayEtrail();
    }
  }
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
